import React, { useEffect, useState } from "react";
import { TextInput, Button, Badge } from "@mantine/core";
import { getRules, saveRules } from "../misc/api";
import RichEditor from "./RichEditor";

export const AdminRuleSystem = () => {
  const [rulePairs, setRulePairs] = useState();
  const [expandedRules, setExpandedRules] = useState({});
  const [allExpanded, setAllExpanded] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRules().then((x) => {
      setRulePairs(x.data);
      const initialExpandedState = {};
      x.data.forEach((rule, index) => {
        initialExpandedState[index] = false;
      });
      setExpandedRules(initialExpandedState);
      setLoading(false);
    });
  }, []);

  const handleInputChange = (index, key, newValue) => {
    const newRulePairs = [...rulePairs];
    newRulePairs[index][key] = newValue;
    setRulePairs(newRulePairs);
  };

  const toggleRuleExpansion = (index) => {
    setExpandedRules((prevExpanded) => ({
      ...prevExpanded,
      [index]: !prevExpanded[index],
    }));
  };

  const toggleAllExpansion = () => {
    setAllExpanded((prev) => !prev);
    const newExpandedState = {};
    rulePairs.forEach((_, index) => {
      newExpandedState[index] = !allExpanded;
    });
    setExpandedRules(newExpandedState);
  };

  const addRulePair = () => {
    const newRule = { title: "", content: "" };
    setRulePairs([...rulePairs, newRule]);

    setExpandedRules((prevExpanded) => ({
      ...prevExpanded,
      [rulePairs.length]: true,
    }));
  };
  const removeRulePair = (index) => {
    const newRulePairs = [...rulePairs];
    const ruleToRemove = newRulePairs[index];

    if (ruleToRemove.id) {
      newRulePairs[index] = { ...ruleToRemove, deleted: true };
    } else {
      newRulePairs.splice(index, 1);
    }

    setRulePairs(newRulePairs);
  };

  const saveRule = async () => {
    setLoading(true);
    try {
      const response = await saveRules(rulePairs);
      // Check for partial failures
      window.location.reload();
    } catch (error) {
      alert("Failed to save: " + error.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          zIndex: 20,
          backgroundColor: "white",
          justifyContent: "space-between",
          // position: "fixed",
          padding: 10,
          width: "-webkit-fill-available",
          // marginLeft: -20,
          marginTop: -20,
        }}
      >
        <h2>Noteikumi</h2>
        <Button
          onClick={() => toggleAllExpansion()}
          style={{ marginTop: 10, marginLeft: 10 }}
        >
          {allExpanded ? "Hide All" : "Expand All"}
        </Button>
      </div>
      <div style={{ paddingTop: 20 }}>
        {rulePairs?.map(
          (rule, index) =>
            !rule.deleted && (
              <div
                key={index}
                style={{
                  padding: 15,
                  backgroundColor: "#f1f1f1",
                  borderRadius: 10,
                  marginBottom: 10,
                }}
              >
                {!expandedRules[index] && (
                  <div
                    onClick={() => toggleRuleExpansion(index)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      marginBottom: 10,
                      textDecoration: "underline",
                    }}
                  >
                    {rule.title_lv || rule.title_en}
                  </div>
                )}
                {expandedRules[index] && (
                  <>
                    <TextInput
                      label="Virsraksts (LV)"
                      value={rule.title_lv}
                      onChange={(event) =>
                        handleInputChange(
                          index,
                          "title_lv",
                          event.currentTarget.value
                        )
                      }
                    />
                    <TextInput
                      label="Virsraksts (EN)"
                      value={rule.title_en}
                      onChange={(event) =>
                        handleInputChange(
                          index,
                          "title_en",
                          event.currentTarget.value
                        )
                      }
                    />
                    <div style={{ marginTop: 15 }}>
                      <label
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: 500,
                          color: "#212529",
                        }}
                      >
                        Saturs LV
                      </label>
                    </div>
                    <RichEditor
                      value={rule?.content_lv}
                      onChange={(val) =>
                        handleInputChange(index, "content_lv", val)
                      }
                    />

                    <div style={{ marginTop: 15 }}>
                      <label
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: 500,
                          color: "#212529",
                        }}
                      >
                        Saturs EN
                      </label>
                    </div>
                    <RichEditor
                      value={rule?.content_en}
                      onChange={(val) =>
                        handleInputChange(index, "content_en", val)
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div></div>
                      <Button
                        onClick={() => removeRulePair(index)}
                        style={{
                          marginTop: 10,
                          backgroundColor: "red",
                          color: "white",
                        }}
                        variant="link"
                      >
                        Remove
                      </Button>
                    </div>
                  </>
                )}
              </div>
            )
        )}
      </div>
      <Button onClick={addRulePair} style={{ marginTop: 10, marginBottom: 40 }}>
        Add Rule
      </Button>
      <hr></hr>
      <div>
        <Button
          onClick={() => saveRule()}
          disabled={loading}
          style={{ marginTop: 10, paddingLeft: 50, paddingRight: 50 }}
        >
          Save
        </Button>
      </div>
    </>
  );
};
